const envPath = window.location.pathname.split("/")[1];

const get = (key) => {
    let pathSpecificKey = `${envPath}_${key}`;
    const item = window.localStorage.getItem(pathSpecificKey);
    
    try {
        return JSON.parse(item);
    } 
    catch {
        return item;
    }
}
const set = (key, value) => {
    let pathSpecificKey = `${envPath}_${key}`;
    window.localStorage.setItem(pathSpecificKey, typeof(value) === "object" ? JSON.stringify(value) : value);
}

const LocalStorage = {
    get : get,
    set : set,
    remove : (key) => window.localStorage.removeItem(key),
    getObjectField: (key, fieldName) => {
        const sessionValue = get(key);
        if(!sessionValue)
            return null;
        else
            return sessionValue[fieldName];
    },
    setObjectField: (key, fieldName, value) => {
        let sessionValue = get(key);
        if(!sessionValue)
            sessionValue = {};
        sessionValue[fieldName] = value;
        set(key, sessionValue)
    }
}

export default LocalStorage

export const Keys = {
    CURRENT_SUBSCRIPTION: "CURRENT_SUBSCRIPTION"
}